export default function (state) {
    let data = [];
    state.filters.forEach(i => {
        let form = {};
        for (let k in i) {
            switch (k) {
                case 'searchClick':
                case 'dateRound':
                case 'dateInt':
                case 'id':
                case 'name':
                    break;
                case 'dateStep':
                    let d1 = new Date();
                    let d2 = new Date();
                    switch (i.dateStep) {
                        case 1:
                            d1.setDate(d1.getDate() - i.dateInt);
                            break;
                        case 2:
                            d1.setDate(d1.getDate() - i.dateInt * 7);
                            break;
                        case 3:
                            d1.setMonth(d1.getMonth() - i.dateInt);
                            if (i.dateRound) {
                                d1.setDate(1);
                            }
                            break;
                    }
                    form.dates = [d1.toStringRu(), d2.toStringRu()];
                    break;
                default:
                    form[k] = i[k];
            }
        }
        data.push({
            id: i.id,
            name: i.name,
            search: i.searchClick,
            form,
        });
    });
    return data;
}